import SVGInjector from 'svg-injector';
import bowser from 'bowser';
import wNumb from 'wnumb';
import noUiSlider from 'nouislider';
import List from 'list.js';
import PageLoader from './Pageloader';
import waitForFinalEvent from './WaitForEvent';
import { Login, checkLogin } from './Login';
import { imgtobg, setViewport } from './helpers';
import { ddBox, tabs, scroll, slickslider, textoverflow } from './snippets';
import { charts } from './charts';
import { Cards } from './cards';
import { RegionMap, MapTool } from './regionMap';
import { SearchPage, SearchInput } from './search';
import { Reports } from './reports';
import { queryInitial, queryChart } from './graphql/queries';

export const _Objects = {
  Page: null,
  RegionMap: null,
  Reports: null,
  Search: null,
  RightPanel: null,
  Total: null,
  Popups: null,
  Filters: {},
  MainStructure: {},
  templates: {
    loader: '<div class="loader"> <div class="loader__view"> <div class="loader__img"> <svg viewBox="0 0 170 170" xmlns="http://www.w3.org/2000/svg"> <path class="loader__path" d="M32 109c0 42.526 34.474 77 77 77s77-34.474 77-77-34.474-77-77-77" transform="translate(-24 -24)" stroke="url(#a_loader)" stroke-width="16" fill="none" fill-rule="evenodd"></path> </svg> </div> </div></div>',
  },

  pageData: 'indicators',
  isLoggedIn: false,
  isLoading: false,
  actualYear: (new Date()).getFullYear()
};

window._Objects = _Objects;

let documentReady = false;
document.addEventListener('orientationchange', () => {
  if (window.isMobile && !window.isTablet) {
    if (window.innerWidth < window.innerHeight) {
      setViewport();
    }
  }
});

$(document).ready(function () {
  documentReady = true;
  if (window.isMobile && !window.isTablet) {
    if (window.innerWidth < window.innerHeight) {  // Проверка на горизонтальную ориентацию на телефоне, чтобы не ломалось всё
      setViewport();
    }
  }
});

PageLoader.getInstance().show('page');

checkLogin().then(() => {
  if (documentReady) {
    initApp();
  } else {
    $(document).ready(function () {
      initApp();
    });
  }
});


function initApp() {

  //### FUNCS ###
  svgInject();
  imgtobg();
  ddBox();
  // textoverflow();
  // slickslider();
  // remodalInit();
  // remodalopen();

  tabs();
  scroll();
  slickslider();

  initObjects();

  // $(window).on('page.inited', function () {
  //     initObjects();
  // });
}

function initObjects() {

  PageLoader.getInstance().show('firstInit');
  $('.js-swiper').each((i, sw) => new Swipe(sw));

  _Objects.Page = new Page('.js-page');
  _Objects.Timeline = new Timeline('.js-timeline');

  $('.js-ddmenu').each((i, ddmenu) => new DDMenu(ddmenu));
  $('.js-select').each((i, select) => new Select(select));
  $('.js-toggle').each((i, toggle) => new Toggle(toggle));
  $('.js-readyranger').each((i, ranger) => new ReadyRanger(ranger));
  $('.js-dragbox').each((i, db) => new DragBox(db));

  _Objects.Login = new Login('.js-login');
  _Objects.RightPanel = new RightPanel('.js-right-panel');
  _Objects.Total = new Total('.js-total');
  _Objects.Popups = new Popups('[data-popup-id]');

  PageLoader.getInstance().show('cardsInit');
  _Objects.MapData = new MapData();
  _Objects.Search = new Search('.js-search');
  _Objects.Cards = new Cards('.js-cards');
  _Objects.RegionMap = new RegionMap('.js-map');
  $('.js-map-tool').each((i, tool) => new MapTool(tool));
  _Objects.Cards.init().then((data) => {
    PageLoader.getInstance().hide('cardsInit');
  });

  _Objects.Reports = new Reports('.js-reports');

  _Objects.isLoading = true;
  queryInitial().then(({ data: { structure } }) => {
    $.each(structure, (i, item) => {
      if (_Objects.MainStructure[ item.type ]) return true;
      _Objects.MainStructure[ item.type ] = {
        id: item.id,
        childList: item.childList,
      };
    });

    PageLoader.getInstance().show('charts');
    charts(_Objects.MainStructure[ 'TYPE_MAIN' ].childList[ 0 ].id);
    PageLoader.getInstance().hide('firstInit');
  });

  _Objects.Page.initPage();

}


// detect device

$(function () {
  console.log(bowser);

  let br_classes = [];
  let browserName = bowser.name.toLowerCase();
  br_classes.push(bowser.msie ? 'ie' : browserName);
  if (bowser.mobile || bowser.tablet) br_classes.push('mobile');
  if (bowser.iphone) br_classes.push('mobile_iphone');
  if (bowser.ipad) br_classes.push('mobile_ipad');
  if (bowser.mac) {
    br_classes.push('macos');
  } else if (!bowser.mobile && !bowser.tablet) {
    br_classes.push('windows');
  }
  window.isMobile = bowser.mobile || bowser.tablet || false;
  window.isTablet = bowser.tablet || false;

  $('html').addClass(br_classes.join(' '));
});

// svg

export function svgInject(pic) {
  var svgPic = (pic && pic.length) ? pic : document.querySelectorAll('img.svg-pic');

  var picCnt = $(svgPic).length;
  var cnt = 1;

  var options = {
    evalScripts: 'false',
    each: function ($svg) {
      if ($('html').is('.page_ready')) return false;
      if (cnt === picCnt) {
        // $('html').addClass('page_inited');
        // $(window).trigger('page.inited');
        setTimeout(function () {
          $('html').addClass('page_ready');
        }, 800);
      } else {
        cnt++;
      }
    },
  };

  SVGInjector(svgPic, options);
}

// OBJECTS

// page switch

class Page {
  constructor(selector) {
    let _this = this;

    _this.$container = $(selector);
    _this.$pageBtn = $('[data-page-target]');
    _this.pageDataArray = [ 'indicators', 'build-progress', 'reports', 'about' ];
    _this.hash = window.helpers.hash.gethashnoext() || null;
    _this.inited = false;

    // _this.$container.data('_page', _this);

    _this.init();
  }

  init() {
    let _this = this;
    let $container = _this.$container;
    let $pageBtn = _this.$pageBtn;

    $pageBtn.on('click.page', function (e) {
      let $currBtn = $(this);
      let pageData = $currBtn.data('page-target');

      if (_Objects.pageData !== pageData) {
        _this.setPage(pageData);
      }
    });

    $container.on('setPage', function (e, pageData) {
      _this.setPage(pageData);
    });
    $container.on('pageSet', function (e, pageData) {
      _this.hash = pageData;
      window.helpers.hash.sethash(pageData);

      _Objects.Search.hide();
    });
  }

  initPage() {
    let _this = this;

    let pageData = _Objects.pageData;
    if (_this.hash && _this.pageDataArray.indexOf(_this.hash) > -1) {
      pageData = _this.hash;
    }
    _this.setPage(pageData, () => {
      PageLoader.getInstance().hide('page');
      _this.inited = true;
      $('html').addClass('page-inited');
    });
  }

  setPage(pageData, callback) {
    let _this = this;
    let $container = _this.$container;
    let $pageBtn = _this.$pageBtn.add($('[data-popup-target="login"]'));
    const $loginPopup = $('[data-popup-target="login"]');

    pageData = pageData || _Objects.pageData;
    if (pageData === 'reports' && !_Objects.isLoggedIn)
      pageData = (_Objects.pageData === pageData) ? 'indicators' : _Objects.pageData;

    _Objects.pageData = pageData;

    $container.add($('html')).data('page', _Objects.pageData);
    $container.add($('html')).attr('data-page', _Objects.pageData);

    $pageBtn.removeClass('_active');
    $loginPopup.removeClass('_active');
    $pageBtn.filter('[data-page-target="' + _Objects.pageData + '"]').addClass('_active');
    if (_Objects.pageData === 'about') {
      $loginPopup.addClass('_active');
    }

    switchPageReqs(pageData);
    $container.trigger('pageSet', [ _Objects.pageData ]);
    if (callback) callback();
  }
}

function switchPageReqs(pageData) {
  let map = $('.js-map');
  if ($('html').is('.map_level_4')) {
    _Objects.RegionMap.ObjectPage.hide();
  }

  if (pageData === 'indicators') {

    map.trigger('panzoom.reset', [ function () {
      map.trigger('panzoom.disable');
    } ]).trigger('selecting.disable');

  } else if (pageData === 'build-progress') {

      map.trigger('selecting.enable')
        .trigger('panzoom.enable');

  } else if (pageData === 'reports') {

    if (!_Objects.isLoggedIn) return false;
    map.trigger('panzoom.reset', [ function () {
      map.trigger('panzoom.disable');
    } ]).trigger('selecting.disable');

  } else if (pageData === 'about') {
    map.trigger('panzoom.reset', [ function () {
      map.trigger('panzoom.disable');
    } ]).trigger('selecting.disable');

    $('.js-login').closest('.js-ddmenu').trigger('ddmenu.hide');
    _Objects.Popups.hideAll();
  }
}

// Total indicators

class Total {
  constructor(selector) {
    let _this = this;

    _this.$container = $(selector);
    _this.$swipable = _this.$container.data('_hammer');
    _this.$slider = _this.$container.find('.js-total-slider');
    _this.$toggle = _this.$container.find('.js-total-toggle');
    _this.$chart = _this.$container.find('.js-total-chart');
    _this.$pag = _this.$container.find('.total__pag');
    _this.type = null;
    _this.typesArray = $.map(_this.$toggle, function (item) {
      return $(item).data('type');
    });

    _this.$container.data('total', _this);

    _this.init();
  }

  init() {
    let _this = this;
    let $container = _this.$container;
    let $toggle = _this.$toggle;
    let type = $container.data('total-type');
    let $swipable = _this.$swipable || null;

    $container.on('change', function (e, type) {
      _this.type = type;
      $container.data('total-type', type).attr('data-total-type', type);
      $container.trigger('changed', [ type ]);
    });
    $toggle.on('click', function (e) {
      e.preventDefault();
      let $currToggle = $(this);
      let type = $currToggle.data('type');

      _this.setTotalType(type);
    });

    if (window.helpers.pos.width() <= 600) {

      _this.$slider.on('beforeChange', (e, slick, currentSlide, nextSlide) => {
        let $nextSlide = slick.$slides.filter((i, slide) => +$(slide).data('slick-index') === nextSlide);
        let nextType = $nextSlide.find(_this.$chart).data('type');
        _this.setTotalType(nextType);
      });

      _this.initSlider();
    }

    // if ($swipable) {
    //   $swipable.on('swipeleft swiperight', function (e) {
    //     let eType = e.type;
    //
    //     _this.changeType(eType === 'swiperight' ? 'prev' : 'next');
    //   });
    // }

    // _this.setTotalType(type || $toggle.filter('._active').data('type') || $toggle.first().data('type'));
    _this.setTotalType($toggle.first().data('type'));
  }
  initSlider() {
    let _this = this;
    let $slider = _this.$slider;

    var config = {
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      focusOnSelect: false,
      speed: 300,
      useTransform: true,
      draggable: false,
      adaptiveHeight: false,
      fade: false
    };

    $slider.data('_slickconfig', config);
    $slider.slick(config);
    $slider.on('beforeChange afterChange', function(e, slick, currentSlide, nextSlide) {
      e.stopPropagation();
    });
  }

  setTotalType(type) {
    let _this = this;
    let $chart = _this.$chart;
    let $toggle = _this.$toggle;
    let $pag = _this.$pag;
    let $container = _this.$container;

    $chart.add($toggle).add($pag).removeClass('_active');
    $chart.add($toggle).add($pag).filter('[data-type="' + type + '"]').addClass('_active');

    $container.trigger('change', [ type ]);
    // _this.setChartType(type).then((type) => {
    //     $container.trigger('changed', [type]);
    // });
  }

  setChartType(type) {
    let _this = this;
    let $chart = _this.$chart;

    return _this.requestChartData(type).then((data) => {

      // set chart data

    });
  }

  changeType(dir = 'next') {
    let _this = this;
    let currType = _this.type;
    let typesArr = _this.typesArray;
    let currTypeIndex = typesArr.indexOf(currType);

    let nextType = currType;
    if (dir === 'prev') {
      nextType = (currTypeIndex === 0) ? typesArr[ typesArr.length - 1 ] : typesArr[ currTypeIndex - 1 ];
    } else {
      nextType = (currTypeIndex === typesArr.length - 1) ? typesArr[ 0 ] : typesArr[ currTypeIndex + 1 ];
    }

    _this.setTotalType(nextType);
  }

  requestChartData(type) {
    let _this = this;
    let $chart = _this.$chart;

    return new Promise(function (resolve, reject) {

      // request chart data

      resolve(type);

    });
  }
}

// ddmenu

class DDMenu {
  constructor(selector) {
    let _this = this;

    _this.$container = $(selector);
    _this.$btn = _this.$container.find('.js-ddmenu-btn');
    _this.$dropdown = _this.$container.find('.js-ddmenu-dropdown');
    _this.$scroll = _this.$container.find('.js-ddmenu-scroll');
    _this.init();
  }

  init() {
    let _this = this;

    _this.initEvents();
  }

  initEvents() {
    let _this = this;
    let $container = _this.$container;
    let $btn = _this.$btn;

    $container.on('ddmenu.show', function () {
      if ($container.is('._locked')) return false;
      _this.show();
      _this.hideOthers();
    });
    $container.on('ddmenu.hide', function (e, noAnimation) {
      _this.hide(noAnimation);
    });
    $container.on('ddmenu.hidden', function () {
      let $login = $container.find('.js-login');
      if ($login && $login.length) $login.trigger('reset');
    });

    $btn.on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (!$container.is('._dd-active')) {
        // _this.show();
        $container.trigger('ddmenu.show');
      } else {
        $container.trigger('ddmenu.hide');
        // _this.hide();
      }
    });

    $(document).on('click', function (e) {
      let $target = $(e.target);
      if ($container.is('._dd-active') && !$target.closest($container).length) {
        $container.trigger('ddmenu.hide');
      }
    });
  }

  show() {
    let _this = this;
    let $container = _this.$container;
    let $dropdown = _this.$dropdown;
    let $btn = _this.$btn;

    _this.setDDHeight();
    $dropdown.add($btn).add($container).addClass('_dd-active');
    setTimeout(function () {
      $container.addClass('_dd-opened');
      $container.trigger('ddmenu.showed');
    }, 300);
  }

  hide(noAnimation = false) {
    let _this = this;
    let $container = _this.$container;
    let $dropdown = _this.$dropdown;
    let $btn = _this.$btn;

    // if (noAnimation) { $dropdown.addClass('_noanim'); }
    $dropdown.add($btn).add($container).removeClass('_dd-active');
    setTimeout(function () {
      $container.removeClass('_dd-opened');
      $container.trigger('ddmenu.hidden');
    }, 300);
    // $dropdown.removeClass('_noanim');
  }

  setDDHeight() {
    let _this = this;
    let $scroll = _this.$scroll;

    if (!$scroll.length) return false;
    let ddPosParams = _this.setDDPosition();
    $scroll.css('max-height', ddPosParams.maxHeight - 20);
  }

  setDDPosition() {
    let _this = this;
    let $dropdown = _this.$dropdown;
    let $scroll = _this.$scroll;
    $dropdown.removeClass('_up');

    // let ddHeight = $dropdown.innerHeight();
    let winHeight = window.helpers.pos.height();
    let ddTop = $dropdown.offset().top;
    let scrollTop = $scroll.offset().top;
    let ddAvailHeight = winHeight - ddTop;
    let isUp = ddAvailHeight < 50 && ddTop > ddAvailHeight;
    $dropdown.toggleClass('_up', isUp);
    return {
      position: isUp ? 'up' : 'down',
      maxHeight: ddAvailHeight - (scrollTop - ddTop),
    };
  }

  hideOthers() {
    let _this = this;
    let $container = _this.$container;

    let $otherContainer = $('.js-ddmenu._dd-active').not($container);
    if (!$otherContainer.length) return false;

    let $otherDropdown = $otherContainer.find('.js-ddmenu-dropdown');
    let $otherBtn = $otherContainer.find('.js-ddmenu-btn');

    $otherDropdown.add($otherBtn).add($otherContainer).removeClass('_dd-active');
    setTimeout(function () {
      $otherContainer.removeClass('_dd-opened');
    }, 300);
  }
}

// search

class Search {
  constructor(selector) {
    let _this = this;

    _this.$container = $(selector);
    _this.$btnOpen = _this.$container.find('.js-search-btn');
    _this.$btnSubmit = _this.$container.find('.js-search-submit');
    _this.$inpBox = _this.$container.find('.js-search-box');
    _this.isActive = false;
    _this.isFocused = false;
    _this.isLoading = false;
    _this.mapData = _Objects.MapData;
    _this.init();
  }

  init() {
    let _this = this;

    _this._searchPage = new SearchPage('.js-search-page');
    _this._searchInput = new SearchInput('.js-search-input');
    _this.setLoading(true);
    _this.initEvents();
  }

  initEvents() {
    let _this = this;
    let $container = _this.$container;
    let $btnOpen = _this.$btnOpen;
    let $btnSubmit = _this.$btnSubmit;
    let $input = _this._searchInput.$container;

    $container.on('s.show', function () {
      _this.show();
    });
    $container.on('s.hide', function () {
      _this.hide();
    });
    $container.on('s.closed', function () {
      $input.val('');
    });
    $container.on('s.opened', function () {
      $input.focus();
    });

    $btnOpen.on('click', function (e) {
      e.preventDefault();
      if (_this.isLoading) return false;
      if (!_this.isActive) {
        _this.show();
      } else {
        _this.hide();
      }
    });

    $input.on('keydown', async (e) => {
      let keycode = (e.keyCode ? e.keyCode : e.which);

      // Enter
      if (+keycode === 13) {
        if (_this.isLoading) return false;
        await _this.goSearch();
      }
    });
    $btnSubmit.on('click', async function (e) {
      e.preventDefault();
      if (_this.isLoading) return false;
      await _this.goSearch();
    });

    $(document).on('keydown', function (e) {
      let keycode = (e.keyCode ? e.keyCode : e.which);
      if (_this.isActive && +keycode === 27) {
        _this.hide();
      }
    });
  }

  show() {
    let _this = this;
    let $container = _this.$container;

    if (_this.isActive) return false;
    $container.addClass('_search-active');
    setTimeout(function () {
      $container.addClass('_search-opened');
      $container.trigger('s.opened');
    }, 300);
    _this.isActive = true;
  }

  hide() {
    let _this = this;
    let $container = _this.$container;

    if (!_this.isActive) return false;
    _this._searchPage.hide();

    $container.removeClass('_search-active');
    setTimeout(function () {
      $container.removeClass('_search-opened');
      $container.trigger('s.closed');
    }, 300);
    _this.isActive = false;
  }

  async goSearch() {
    let _this = this;
    _this._searchInput.$container.blur();

    if (_Objects.isLoading) return false;

    let inputValue = _this._searchInput.getValue();
    if (!inputValue.length) return false;
    _this.getSearchResultsData(inputValue.toLowerCase());
    _this._searchPage.show();
  }

  async getSearchResultsData(searchString) {
    let _this = this;
    let _searchPage = _this._searchPage;
    const structureData = _this.findElements(searchString);
    const queryParams = _this.getSearchQueryParams(structureData);

    _searchPage.setLoading(true);
    await _this.setQueryData(queryParams);
    _searchPage.setLoading(false);

    const items = _this.getItemsData(structureData);
    const cards = _this.getCards(searchString);

    _searchPage.setResults({ items, cards });
  }

  findElements(searchString) {
    const _this = this;
    const mapData = _this.mapData;
    return mapData.getSearchData().filter(({ meta }) => {
      const name = JSON.parse(meta).name.toLowerCase();
      return (name.indexOf(searchString) > -1);
    });
  }

  static parseStructureType(type) {
    switch (type) {
      case 'fo':
        return 'district';
      case 'subj':
        return 'subject';
      case 'obj':
        return 'object';
      default:
        break;
    }
  };

  getSearchQueryParams(structureElems) {
    const _this = this;
    const mapData = _this.mapData;
    const currentYear = _Objects.Timeline.getValue();
    const neededSearchElems = [];
    structureElems.forEach((elem) => {
      const structureType = Search.parseStructureType(elem.type);
      const elemData = mapData.getElementData(structureType, elem.name);
      if (undefined === elemData) {
        const newElem = { ...elem, type: structureType };
        neededSearchElems.push(newElem);
      }
    });
    if (neededSearchElems.length) {
      const ids = neededSearchElems.sort(({yearId: a}, {yearId: b}) => {
        if (a < b) return -1;
        else if (a > b) return 1;
        return 0;
      }).map(({ yearId }) => yearId);
      return {
        queryParams:
          {
            id: ids,
            year: currentYear,
          },
        neededSearchElems,
      };
    }

    return null;
  }

  async setQueryData(params) {
    const _this = this;
    const mapData = _this.mapData;
    if (params) {
      const { queryParams, neededSearchElems } = params;
      const { data } = await queryChart(queryParams);
      mapData.setSearchStaticData(data.chart, neededSearchElems);
    }

  }

  getItemsData(searchItems) {
    const _this = this;
    const mapData = _this.mapData;
    const items = [];
    const indicators = {
      'fo': '12',
      'subj': '14',
      'obj': '113',
    };

    const getDataObject = (data, indicator) => {
      return data.find((item) => item.name === 'Столбец' + indicator) || { value: 0 };
    };

    searchItems.forEach((item) => {
      const structureName = Search.parseStructureType(item.type);
      const data = mapData.getElementData(structureName, item.name);
      const financing = getDataObject(data.staticData, indicators[ item.type ]).value;
      if (item.type !== 'obj' && (!financing || financing === '0')) {
        return;
      }
      const itemMeta = JSON.parse(item.meta);

      let parent = null;
      if (item.type === 'subj') {
        parent = mapData.findStructureElementByName('district', `${itemMeta.parent_code}`);
      } else if (item.type === 'obj') {
        parent = mapData.findStructureElementByName('subject', '' + `${itemMeta.parent_code}`);
      }

      const parentName = (parent) ? JSON.parse(parent.meta).name : '';

      const mapObj = { id: item.name, name: itemMeta.name, parentName, type: item.type, financing };

      items.push(mapObj);
    });

    return items;
  }

  getCards(searchString) {
    const _this = this;
    const $cards = _Objects.Cards.$cards;

    return $cards.filter((card) => {
      const $card = $(card);
      const cardName = $card.find('.js-card-object-text').text().toLowerCase();
      return (cardName.indexOf(searchString) > -1);
    });
  }

  setLoading(isLoading = false) {
    let _this = this;

    _this.isLoading = isLoading;
    _this.$container.toggleClass('_loading', isLoading);
    _this._searchPage.setLoading(isLoading);
  }
}

// ranger

class Ranger {
  constructor(selector, config) {
    let _this = this;
    _this.$container = $(selector);
    // _this.initValue = initValue || null;
    _this.config = config || {};
    _this.defConfig = {
      start: [ 0 ],
      connect: true,
      range: {
        'min': 0,
        'max': 0,
      },
      step: 1,
    };

    _this._container = this;
    _this.$container.data('_ranger', _this._container);

    _this.init();
  }

  init() {
    let _this = this;
    let $container = _this.$container;
    let _ranger = _this._ranger = $container[ 0 ];

    let config = { ..._this.defConfig, ..._this.config };
    noUiSlider.create(_ranger, config);

    _this.initEvents();
  }

  initEvents() {
    let _this = this;
    let $container = _this.$container;
    let _ranger = _this._ranger;

    $container.on('ranger.update', function (e, values) {
      _ranger.noUiSlider.set(values);
    });
  }

  set(values) {
    let _this = this;
    let _ranger = _this._ranger;

    _ranger.noUiSlider.set(values);
  }
}

// timeline

class Timeline {
  constructor(selector) {
    let _this = this;
    _this.$container = $(selector);
    _this.range = _this.$container.data('range');
    _this.value = null;
    _this._container = this;

    _this.$container.data('_timeline', _this._container);
    _this.init();
  }

  init() {
    let _this = this;
    let $container = _this.$container;
    let range = _this.range;
    _this.value = _Objects.actualYear;

    _this.setMarkdown(function () {
      _this.initEvents();

      let _tl = _this.Ranger = new Ranger($container[ 0 ], {
        start: _this.value,
        range: {
          min: range[ 0 ],
          max: range[ 1 ],
        },
        connect: [ true, false ],
        // pips: { mode: 'count', values: range[1] - range[0] + 1 }
      });

      _tl._ranger.noUiSlider.on('set', function () {
        setTimeout(() => {
          $container.trigger('changed', [ _tl._ranger.noUiSlider.get() ]);
        }, 230);
      });
      _tl._ranger.noUiSlider.on('update', function () {
        $container.trigger('yearChanged', [ _tl._ranger.noUiSlider.get() ]);
      });
    });
  }

  initEvents() {
    let _this = this;
    let $container = _this.$container;
    let $years = _this.$years;

    $container.on('changed', function (e, value) {
      _this.value = value;
    });
    $container.on('yearChanged', function (e, value) {
      _this.setActiveYear(+value);
    });
    $container.on('tl.set', function (e, value) {
      _this.Ranger.set(value);
    });

    $years.on('click', function (e) {
      e.preventDefault();

      let $currYear = $(this);
      let yearData = $currYear.data('year');
      $container.trigger('tl.set', [ yearData ]);
    });
  }

  setActiveYear(yearValue) {
    let _this = this;
    let $years = _this.$years;

    $years.removeClass('_past _active');

    $.each($years, function (i, year) {
      let $currYear = $(year);
      let yearData = +$currYear.data('year');

      if (yearData < yearValue) {
        $currYear.addClass('_past');
      } else if (yearData === yearValue) {
        $currYear.addClass('_active');
      }
    });
  }

  setMarkdown(callback) {
    let _this = this;
    let $container = _this.$container;
    let range = _this.range;

    let $wrapp = $('<div class="timeline__wrapp" />');

    $container.empty();
    let $years = $('<div class="timeline__years" />');
    for (let i = range[ 0 ]; i <= range[ 1 ]; i++) {
      let $yearItem = $('<div class="timeline__year js-tl-point"> <div class="timeline__year-val"> <span>' + i + '</span> </div> </div>');
      $yearItem.data('year', i);

      $years.append($yearItem);
    }

    $container.append($wrapp.append($years));
    // $container.append($years);
    _this.$years = $container.find('.js-tl-point');

    if (callback) callback();
  }

  getValue() {
    let _this = this;

    return +_this.value;
  }

  static get(id) {
    let data = $('.js-timeline[data-timeline-id="' + id + '"]').data('_timeline');
    return data || null;
  }
}

// ready ranger

export class ReadyRanger {
  constructor(selector) {
    let _this = this;
    _this.$container = $(selector);
    _this.$persItems = _this.$container.find('.ready-ranger__item');
    _this.Ranger = null;
    _this.initialValue = [ 0, 100 ];
    _this._container = this;

    _this.$container.data('_readyranger', _this._container);
    _this.init();
  }

  init() {
    let _this = this;
    let $container = _this.$container;
    _this.value = _this.initialValue;

    _this.initEvents();
    _this.initRanger();
  }

  initRanger() {
    let _this = this;
    let $container = _this.$container;

    let _readyRanger = _this.Ranger = new Ranger($container, {
      start: _this.initialValue,
      range: {
        'min': 0,
        '25%': 30,
        '50%': 50,
        '75%': 80,
        'max': 100,
      },
      connect: [ true, false, true ],
      tooltips: [ wNumb({ decimals: 0, suffix: '%' }), wNumb({ decimals: 0, suffix: '%' }) ],
      // pips: { mode: 'count', values: range[1] - range[0] + 1 }
    });

    $container.trigger('rr.updated', [ _readyRanger._ranger.noUiSlider.get() ]);
    _readyRanger._ranger.noUiSlider.on('update', function () {
      $container.trigger('rr.updated', [ _readyRanger._ranger.noUiSlider.get() ]);
    });
    _readyRanger._ranger.noUiSlider.on('set', function () {
      $container.trigger('changed', [ _readyRanger._ranger.noUiSlider.get() ]);
    });
  }

  initEvents() {
    let _this = this;
    let $container = _this.$container;

    $container.on('changed', function (e, value) {
      _this.value = value;
    });
    $container.on('rr.updated', function (e, values) {
      _this.setActivePerc(values);
      $container.attr('data-low-sector', _this.getSectorByValue(+values[ 0 ]));
      $container.attr('data-up-sector', _this.getSectorByValue(+values[ 1 ]));
    });
    $container.on('rr.set', function (e, values) {
      _this.Ranger.set(values);
    });
  }

  getSectorByValue(value) {
    value = +value;
    let sector = 1;

    if (value < 30) {
      sector = 1;
    } else if (value >= 30 && value < 50) {
      sector = 2;
    } else if (value >= 50 && value < 80) {
      sector = 3;
    } else if (value >= 80 && value < 100) {
      sector = 4;
    } else if (value === 100) {
      sector = 5;
    }

    return sector;
  }

  setActivePerc(values) {
    let _this = this;
    let $persItems = _this.$persItems;

    let lowerValue = +values[ 0 ];
    let upperValue = +values[ 1 ];

    $persItems.removeClass('_hidden');

    let $outPercItems = $persItems.filter(function (i, item) {
      let $currItem = $(item);
      let $currItemValue = $currItem.find('.ready-ranger__item-value');
      let percData = +$currItemValue.data('value');
      return percData <= lowerValue || percData >= upperValue;
    });

    $outPercItems.addClass('_hidden');
  }

  getValue() {
    let _this = this;

    return $.map(_this.value, (item) => +item);
  }

  setValue(values) {
    let _this = this;
    _this.Ranger.set(values);
  }
}

// scroll slider

export class ScrollSlider {
  constructor(selector) {
    let _this = this;
    _this.ID = selector.id;
    _this.$container = $(selector);
    _this.$scroll = null;
    _this.$cont = null;
    _this.$list = null;
    _this.$slides = null;
    _this.$offsetLeft = null;
    _this.$offsetRight = null;
    _this.$slideBtn = $('.js-scrollslider-btn[data-slider="' + _this.ID + '"]');

    _this.autoScroll = false;
    _this.autoScrollValue = null;
    _this.activeSlideIndex = 0;

    _this.init();
  }

  init() {
    let _this = this;

    _this.isMobile = window.helpers.pos.width() < 750;

    // _this.initMarkdown();
    _this.initEvents();
  }

  initMarkdown() {
    let _this = this;
    let $container = _this.$container;
    let $scroll = $('<div class="scrollslider__scroll" />');
    let $cont = $('<div class="scrollslider__cont" />');
    let $list = $('<div class="scrollslider__list" />');
    let $slide = $('<div class="card__slide scroll-slide js-slide" />');
    let $offsetLeft = $('<span class="scrollslider__offset scrollslider__offset_left" />');
    let $offsetRight = $('<span class="scrollslider__offset scrollslider__offset_right" />');
    let $items = $container.children('div');

    // $list.append($slides);
    let $slides = $.map($items, (item) => {
      let $newSlide = $slide.clone(false);
      return $newSlide.append(item)[ 0 ];
    });
    $list.append($offsetLeft).append($slides).append($offsetRight);
    $cont.append($list);
    $scroll.append($cont);
    $container.append($scroll);
    $slides = $list.find('.scroll-slide');

    $container.data('scrollslider', {
      $scroll, $cont, $list, $slides, $items,
    });
    $.each($slides, function (i, slide) {
      $(slide).data('slide-index', i);
    });

    _this.$scroll = $scroll;
    _this.$cont = $cont;
    _this.$list = $list;
    _this.$slides = $slides;
    _this.$items = $items;
    _this.$offsetLeft = $offsetLeft;
    _this.$offsetRight = $offsetRight;
  }

  initEvents() {
    let _this = this;
    let $container = _this.$container;

    if (_this.$scroll) _this.initScrollEvents();
    $container.on('afterScroll', () => {
      let $activeSlide = _this.scrollToSlide();
    });
    $container.on('slideTo', (e, slideIndex, isAnimated) => {
      _this.scrollToSlide(slideIndex, isAnimated);
    });
    $container.on('setPosition', () => {
      _this.setPosition();
    });
    $container.on('scrollFinished', (e, $activeSlide) => {
      let $slides = _this.$slides;
      let actSlidesIdx = $activeSlide.map((i, slide) => {
        return +$(slide).data('slide-index');
      });
      let minIndex = Math.min.apply(null, actSlidesIdx);
      let maxIndex = Math.max.apply(null, actSlidesIdx);

      $container.toggleClass('_first-active', minIndex === 0);
      $container.toggleClass('_last-active', maxIndex === $slides.length - 1);
    });

    if (_this.$slideBtn.length) {
      _this.$slideBtn.on('click', function (e) {
        e.preventDefault();
        let $currBtn = $(this);
        let actSlideIndex = _this.getActiveSlide().data('slide-index');
        if ($currBtn.is('._prev')) {
          if (actSlideIndex !== 0) _this.scrollToSlide(actSlideIndex - 1);
          else _this.scrollToSlide(0);
        } else {
          if (actSlideIndex !== _this.$slides.length - 1) _this.scrollToSlide(actSlideIndex + 1);
        }
      });
    }

    $(window).on('resize', () => {
      waitForFinalEvent(() => {
        $container.trigger('setPosition');
      }, 10, _this.ID);
    });
  }

  initScrollEvents() {
    let _this = this;
    let $container = _this.$container;
    let $scroll = _this.$scroll;

    function fireAfterScrollEvent() {
	    waitForFinalEvent(() => {
		    scrollTO = setTimeout(() => {
			    $container.trigger('afterScroll');
		    }, 100);
	    }, 100, 'sliderScrollTimeout');
    }

    let scrollTO;
    let mouseDown = false;
    $scroll.on('scroll', (e) => {
      e.stopPropagation();
      if (_this.autoScroll) return false;
      // console.log('manual-scrolling');

	    clearTimeout(scrollTO);
      if (!mouseDown) {
	      fireAfterScrollEvent();
      }
    });

	  $scroll.on('mousedown', (e) => {
		  mouseDown = true;
    });
	  $scroll.on('mouseup', (e) => {
		  mouseDown = false;
		  fireAfterScrollEvent();
    });
	  $scroll.on('touchstart', (e) => {
		  mouseDown = true;
    });
	  $scroll.on('touchend', (e) => {
	    if (e.touches && e.touches.length === 0) {
		    mouseDown = false;
		    fireAfterScrollEvent();
      }
    });
  }

  reinit() {
    let _this = this;

    _this.initMarkdown();
    _this.initScrollEvents();
    _this.setPosition();

    textoverflow(_this.$items.find('.js-textoverflow'));
  }

  setSlides($items) {
    let _this = this;

    _this.$container.empty().addClass('_noslides');
    if ($items && $items.length) {
      _this.$container.append($items).removeClass('_noslides');
      _this.reinit();
    }
  }

  setPosition() {
    let _this = this;
    let $container = _this.$container;
    let $slides = _this.$slides;
    let $offsetLeft = _this.$offsetLeft;
    let $offsetRight = _this.$offsetRight;

    if (_this.isMobile) {
      let containerOffsets = _this.getOffsets($container);
      let slidesOffsets = _this.getOffsets($slides.eq(0));

      $offsetLeft.add($offsetRight).css({
        'width': containerOffsets.width / 2 - slidesOffsets.width / 2,
      });
    }

    if (_this.$cont.innerWidth() > _this.$scroll.innerWidth()) _this.$slideBtn.addClass('_visible');

    $container.trigger('slideTo', [ _this.activeSlideIndex ]);
  }


  // HELPERS

  activateSlide(slideIndex) {
    let _this = this;
    let $slides = _this.$slides;
    let $activeSlide;

    if (_this.isMobile) {
      $activeSlide = $slides.filter((i, slide) => {
        return $(slide).data('slide-index') === slideIndex;
      });
    } else {
      let scrollOffsets = _this.getOffsets(_this.$scroll);
      // console.log('scroll left: ' + scrollOffsets.left, 'right: ' + scrollOffsets.right);
      $activeSlide = $slides.filter((i, slide) => {
        let $slide = $(slide);
        let slideOffsets = _this.getOffsets($slide);
        // console.log('left: ' + parseInt(slideOffsets.left), 'right: ' + parseInt(slideOffsets.right))
        return parseInt(slideOffsets.left) >= parseInt(scrollOffsets.left)
          && parseInt(slideOffsets.right) <= parseInt(scrollOffsets.right + 3);
      });
    }

    $slides.removeClass('slide_active');
    $activeSlide.addClass('slide_active');
    _this.activeSlideIndex = slideIndex;
    return $activeSlide;
  }

  getOffsets($target) {
    let left = $target.offset().left;
    let width = $target.innerWidth();
    return {
      width: width,
      left: left,
      right: left + width,
    };
  }

  getActiveSlide() {
    let _this = this;
    let $scroll = _this.$scroll;
    let $slides = _this.$slides;
    let $activeSlide = null;

    let scrollOffsets = _this.getOffsets($scroll);
    let $currSlides = [];
    $.each($slides, function (slideIndex, slide) {
      let $slide = $(slide);

      let left = $slide.offset().left;
      let right = $slide.offset().left + $slide.innerWidth();

      if ((left >= scrollOffsets.left && left <= scrollOffsets.right)
        || right >= scrollOffsets.left && right <= scrollOffsets.right) {
        $currSlides.push({
          el: $slide,
          offsets: { left, right },
        });
      }
    });

    if (_this.isMobile) {
      let compareValues = [];
      $.each($currSlides, function (i, slide) {
        if (slide.offsets.left <= scrollOffsets.left) {
          compareValues.push(slide.offsets.right - scrollOffsets.left);
        } else if (slide.offsets.right >= scrollOffsets.right) {
          compareValues.push(scrollOffsets.right - slide.offsets.left);
        } else {
          compareValues.push(slide.offsets.right);
        }
      });
      $activeSlide = $currSlides[ $.inArray(Math.max.apply(null, compareValues), compareValues) ].el;
    } else {
      let firstSlide = $currSlides[ 0 ];
      let firstSlideLeft = firstSlide.offsets.left;
      let firstSlideRight = firstSlide.offsets.right;

      $activeSlide = (firstSlideRight >= firstSlide.el.innerWidth() / 2)
        ? firstSlide.el
        : $currSlides[ 1 ].el;
    }

    return $activeSlide;
  }

  scrollToSlide(activeSlideIndex, isAnimated = true) {
    let _this = this;
    let $container = _this.$container;
    let $scroll = _this.$scroll;
    let $slides = _this.$slides;

    let $activeSlide = (activeSlideIndex == undefined || activeSlideIndex == null)
      ? $(_this.getActiveSlide()[ 0 ])
      : $slides.filter((i, slide) => {
        return $(slide).data('slide-index') == activeSlideIndex;
      });
    let scrollOffsets = _this.getOffsets($scroll);
    let slideOffsets = _this.getOffsets($activeSlide);

    _this.autoScroll = true;
    _this.autoScrollValue = _this.isMobile
      ? $activeSlide.position().left - (scrollOffsets.width / 2 - slideOffsets.width / 2)
      : $activeSlide.position().left;

    let speed = isAnimated ? 500 : 0;
    $scroll.finish().animate({
      'scrollLeft': _this.autoScrollValue,
    }, speed, () => {
      $scroll.scrollLeft(_this.autoScrollValue);
      setTimeout(function () {
        _this.autoScroll = false;
        let $activatedSlides = _this.activateSlide($activeSlide.data('slide-index'));
        $container.trigger('scrollFinished', [ $activatedSlides ]);
      }, 1);
    });

    return $activeSlide;
  }
}

// Select

export class Select {
  constructor(selector) {
    // let _this = this;
    this.$container = $(selector);
    this.$select = this.$container.find('.js-select-select');
    this.$selectOptions = this.$select.find('option');
    this.options = false;
    this.selectId = this.$select[ 0 ].id;
    this.isMulti = this.$select.is('[multiple]');
    this.$placeholder = this.$container.find('.js-select-placeholder');
    this.$selectedBox = this.$container.find('.js-select-selected-box');
    this.$selectedText = this.$container.find('.js-select-selected-text');
    this.$selectList = this.$container.find('.js-select-list');
    this.$search = null;

    this.dataType = this.$container.data('data-type') || null;
    this.chainData = this.$container.data('chain') || null;
    this.chainOrder = +this.$container.data('chain-order') || 1;
    this.name = this.$container.data('name') || null;
    this.isLocked = false;
    this.isInited = false;
    this.isFilterable = !!this.$selectList.data('listsort') || false;
    this.isSearchable = !!this.$selectList.is('._searchable');
    this.isChained = !!this.chainData || false;


    this.templates = {
      selectItem: '<div class="select-item"> <input type="" id="" name="" value="" class="js-select-checker select-item__check"> <label for="" class="select-item__lbl"> <span class="lbl__text select-item__text"></span> </label> </div>',
      selectedItem: '<div class="select__selected-item js-select-selected-item"> <span class="select__selected-item__text"></span> <div class="select__selected-item__remove"> <i><img src="/img/icons/i-close.svg" alt="" class="svg-pic"></i> </div> </div>',
      search: '<div class="bubble-select__search js-select-search"> <input type="text" class="bubble-select__search-inp js-select-search-inp" placeholder="Поиск"> <i class="bubble-select__search-icon"><img src="img/icons/i-search.svg" alt="" class="svg-pic"></i> </div>',
    };
    // this.$checker = this.$container.find('.js-select-checker');


    this._container = this;
    this.$container.data('_select', this);

    if (this.$container.data('select-id') === 'period')
      _Objects.Filters.Period = this;

    this.init();
  }

  init() {
    let _this = this;
    let $container = _this.$container;

    $container.toggleClass('_multiple', _this.isMulti);

    _this.setMarkdown().then(function () {
      _this.initEvents();
      if (!_this.isChained) _this.resetValues();
      _this.initValue();
      if (_this.isChained) _this.initChaining();
      if (_this.isFilterable) _this.initListSort({
        valueNames: [ 'select-item__text', { data: [ 'filterid' ] } ],
        listClass: 'js-select-list',
      });
      if (_this.isSearchable) _this.initSearching({
        valueNames: [ 'select-item__text', { data: [ 'filterid' ] } ],
        listClass: 'js-select-list',
      });
      _this.isInited = true;
    });
  }

  reInit() {
    let _this = this;
    return _this.setMarkdown().then(function () {
      _this.initEvents();
      _this.initValue();
      _this.reindexFiltering();
    });
  }

  initEvents() {
    let _this = this;
    let $container = _this.$container;
    let $select = _this.$select;
    let $checker = _this.$checker;

    $checker.off('change').on('change', function () {
      let checkedArray = _this.getChecks();
      _this.setValue(checkedArray, 'checker');
    });
    $checker.off('progChange').on('progChange', function (e) {
      // e.preventDefault();
    });

    if (_this.isInited) return;

    $select.on('change', function (e) {
      let checkedArray = _this.getValue();
      _this.setValue(checkedArray, 'select');
    });
    $container.on('changed', function (e) {
      e.stopPropagation();
      if (!_this.isMulti) _this.hideSelect();
      $container.toggleClass('_has-value', _this.getValue().length > 0);

      if (_this.chainData) {
        _this.resetChain(_this.chainOrder);
        Select.setChainLock(_this.chainData, _this.chainOrder);
        _this.filterChainedSelect(_this.chainOrder);
      }
    });
    $container.on('resetValues', () => {
      _this.resetValues();
    });
    $container.on('filtered', (e, matchingItemsCount, filterEventType) => {
      $container.toggleClass('_noitems', !matchingItemsCount);
    });
    $container.on('lock', () => {
      $container.addClass('_locked');
      _this.isLocked = true;
      _this.hideSelect();
    });
    $container.on('unlock', () => {
      $container.removeClass('_locked');
      _this.isLocked = false;
    });
  }

  initValue() {
    let _this = this;
    let $container = _this.$container;
    let $select = _this.$select;

    let checkedArray = _this.getValue();
    let placeholder = $container.data('placeholder');

    if (!placeholder) {
      if (checkedArray.length) {
        _this.setValue(checkedArray, 'select');
      }
    } else {
      _this.setTextValue(placeholder);
    }
  }

  initListItems() {
    let _this = this;
    let $selectedBox = _this.$selectedBox;
    let $item = $selectedBox.find('.js-select-selected-item');
    let $itemRemoveBtn = $item.find('.select__selected-item__remove');

    $itemRemoveBtn.off('click').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this.resetValues();
    });
  }

  initChaining() {
    let _this = this;
    let $container = _this.$container;
    let chainData = _this.chainData;

    let $prevChainedSelect = $('.js-select[data-chain="' + chainData + '"][data-chain-order="' + (_this.chainOrder - 1) + '"]');
    if ($prevChainedSelect.length) $container.trigger('lock');
  }

  initListSort(params = {}) {
    let _this = this;
    let $container = _this.$container;

    _this.$selectList.data('listSortParams', params);
    _this._listSort = new ListSort(_this.$selectList);

    let _listSortInstance = _this._listSort._listSort;
    _listSortInstance.on('filterComplete', (e) => {
      $container.trigger('filtered', [ _listSortInstance.matchingItems.length, e.type ]);
    });
    _listSortInstance.on('searchComplete', (e) => {
      $container.trigger('filtered', [ _listSortInstance.matchingItems.length, e.type ]);
    });
  }

  initSearching(params = {}) {
    let _this = this;
    let $searchInp = _this.$searchInp;

    if (!_this._listSort) {
      _this.initListSort(params);
    }

    $searchInp.on('keyup', (e) => {
      let currInp = e.currentTarget;
      _this.searchItems(currInp.value.trim());
    });

    $(document).on('keydown', function (e) {
      let keycode = (e.keyCode ? e.keyCode : e.which);
      if ($searchInp.is(':focus') && +keycode === 27) {
        $searchInp.val('');
        $searchInp.blur();
        _this.searchItems();
      }
    });
  }

  reindexFiltering() {
    let _this = this;

    _this._listSort.reIndex();
  }

  searchItems(searhString = '', searchCols) {
    let _this = this;
    _this._listSort.searchValues(searhString, searchCols);
  }

  filterItems(filterString, filterName) {
    let _this = this;
    _this._listSort.filterValues(filterString, filterName);
  }

  setMarkdown() {
    let _this = this;
    let $select = _this.$container;
    let $selectOptions = _this.$selectOptions;
    let $selectList = _this.$selectList;

    return new Promise(function (resolve, reject) {

      if (!_this.isInited) {
        if (_this.isSearchable) {
          let $searchTmpl = $(_this.templates.search);

          _this.$container.find('.ddmenu__cont').prepend($searchTmpl);
          _this.$search = _this.$container.find('.js-select-search');
          let $searchInp = _this.$searchInp = _this.$search.find('.js-select-search-inp');

          $searchInp.data('listsort', _this.$selectList.data('listsort'))
            .attr('data-listsort', _this.$selectList.data('listsort'));
          _this.$container.addClass('_searchable');
          svgInject(_this.$search.find('.svg-pic'));
        }
      }

      $selectList.empty();
      $.each($selectOptions, function (i, option) {

        let $currOption = $(option);
        let value = option.value;

        let $itemTmpl = $(_this.templates.selectItem);

        // checker
        let $itemChecker = $itemTmpl.find('.js-select-checker');
        // $itemChecker[0].id = _this.selectId + '_check_' + i;
        // $itemChecker[0].type = _this.isMulti ? 'checkbox' : 'radio';
        // $itemChecker[0].value = value;
        // $itemChecker[0].name = _this.selectId + '_check';
        $itemChecker.attr('type', _this.isMulti ? 'checkbox' : 'radio');
        $itemChecker.attr('value', value);
        $itemChecker.attr('name', _this.selectId + '_check');
        $itemChecker.attr('id', _this.selectId + '_check_' + i);
        $itemChecker.data('text', option.text);

        // label
        let $itemLabel = $itemTmpl.find('label');
        let $itemLabelText = $itemLabel.find('.lbl__text');
        // $itemLabel[0].for = _this.selectId + '_check_' + i;
        $itemLabel.attr('for', _this.selectId + '_check_' + i);
        $itemLabelText.text(option.text);

        // list <li>
        let $listLi = $('<li class="js-select-list-item" />');
        let extData = $currOption.data('ext');
        $.each(extData, (key, val) => {
          if (val) $listLi.data(key, val).attr('data-' + key, val);
        });

        $listLi.append($itemTmpl);
        $selectList.append($listLi);
      });

      _this.$checker = $selectList.find('.js-select-checker');

      resolve();

    });
  }

  setOptions(options = []) {
    let _this = this;
    let $select = _this.$select;

    if (!options.length) return;
    $select.empty();
    $.each(options, (i, option) => {
      let $newOption = $('<option data-id="' + option.id + '" value="' + option.value + '">' + option.text + '</option>');
      if (option.extData) {
        $newOption.data('ext', option.extData);
      }
      $select.append($newOption);
    });
    _this.$selectOptions = $select.find('option');
    return _this.reInit();
  }

  getChecks() {
    let _this = this;
    let $checker = _this.$checker;

    let checkedArray = $.map($checker, function (checker) {
      if ($(checker).is(':checked'))
        return {
          value: checker.value,
          text: $(checker).data('text'),
        };
    });
    return checkedArray;
  }

  getValue() {
    let _this = this;
    let $selectOptions = _this.$selectOptions;

    let checkedArray = $.map($selectOptions, function (option) {
      if ($(option).is(':selected'))
        return {
          value: option.value,
          text: option.text,
          id: $(option).attr('data-id'),
          el: option,
        };
    });
    return checkedArray;
  }

  getOption(value) {
    let _this = this;
    let $selectOptions = _this.$selectOptions;

    let $currOption = $selectOptions.filter(function (i, option) {
      return option.value === value;
    });

    return $currOption || null;
  }

  setValue(values = [], handler) {
    let _this = this;
    let $container = _this.$container;

    if (handler === 'select') {
      _this.setCheckValue(values);
    } else if (handler === 'checker') {
      _this.setSelectValue(values);
    } else {
      _this.setSelectValue(values);
      _this.setCheckValue(values);
    }

    if (_this.isMulti) {
      _this.setListValues(values);
    } else {
      _this.setTextValue(values);
    }

    $container.trigger('changed');
  }

  setSelectValue(values = []) {
    let _this = this;
    let $selectOptions = _this.$selectOptions;

    $selectOptions.prop('selected', false).attr('selected', false);
    if (values.length) {
      $.each(values, function (i, value) {
        let $currOption = $selectOptions.filter(function (i, option) {
          return option.value === value.value;
        });

        $currOption.prop('selected', true).attr('selected', true);
      });
    }
  }

  setCheckValue(values = []) {
    let _this = this;
    let $checker = _this.$checker;

    $checker.prop('checked', false).attr('checked', false);
    if (values.length) {
      $.each(values, function (i, value) {
        let $currChecker = $checker.filter(function (i, checker) {
          return checker.value === value.value;
        });

        $currChecker.prop('checked', true).attr('checked', true);
      });
    }
  }

  setTextValue(values) {
    let _this = this;
    let $selectText = _this.$selectedText;

    if (!values || !values.length) return false;

    if (typeof values === 'string') {
      $selectText.text(values);
    } else {
      $selectText.text(values[ 0 ].text);
    }
  }

  setListValues(values) {
    let _this = this;
    let $selectedBox = _this.$selectedBox;

    $selectedBox.empty();
    if (values.length) {
      let $itemTmpl = $(_this.templates.selectedItem);
      let $itemText = $itemTmpl.find('.select__selected-item__text');
      let $itemRemoveBtn = $itemTmpl.find('.select__selected-item__remove');

      if (values.length > 1) {
        $itemText.text('Выбрано: ' + values.length);
      } else {
        $itemText.text(values[ 0 ].text);
      }

      $selectedBox.append($itemTmpl);
      _this.initListItems();
      svgInject($itemTmpl.find('img.svg-pic'));
    }
  }

  static setChainLock(chainData, chainOrder = 1) {
    const currentFilter = _Objects.Filters.Period.getValue()[0].value;
    let $chainedSelect = $('.js-select[data-chain="' + chainData + '"]');
    if (!$chainedSelect.length) return;

    let $currSelect = $chainedSelect.filter('[data-chain-order="' + chainOrder + '"]');
    if (!$currSelect.length) return;

    let $nextChainedSelect = $chainedSelect.filter('[data-chain-order="' + (chainOrder + 1) + '"]');
    if (!$nextChainedSelect.length) return;

    if ($nextChainedSelect.data('chain-order') === 3 && currentFilter === 'next') {
      if (!$nextChainedSelect.hasClass('_locked')) {
        $nextChainedSelect.trigger('lock');
      }
      return;
    }

    let currValues = $currSelect.data('_select').getValue();
    $nextChainedSelect.trigger(!currValues.length ? 'lock' : 'unlock');
  }

  filterChainedSelect(chainOrder = 1) {
    let _this = this;
    let $currSelect = _this.$container;

    let $chainedSelect = $('.js-select[data-chain="' + _this.chainData + '"]');
    if (!$chainedSelect.length) return;

    let $nextChainedSelect = $chainedSelect.filter('[data-chain-order="' + (chainOrder + 1) + '"]');
    if (!$nextChainedSelect.length) return;

    let selectedOptionsIdx = $.map($currSelect.data('_select').getValue(), (item) => {
      // return $(item.el).data('ext')['filterId'];
      return item.value;
    });

    $nextChainedSelect.data('_select').filterItems(selectedOptionsIdx, 'filterid');
  }

  selectAll(all = false) {
    let _this = this;
    let $container = _this.$container;
    let $selectOptions = _this.$selectOptions;

    if (_this.isMulti) {
      _this.setValue(all
        ? $selectOptions.map((i, option) => {
          return {
            value: option.value,
            text: option.text,
          };
        })
        : []);
    }
  }

  resetValues() {
    let _this = this;
    if (!_this.isMulti) {
      const { text, value } = _this.$selectOptions[ 0 ];
      _this.setValue([ { text, value } ]);
    } else {
      _this.setValue(0);
    }
  }

  resetChain(chainOrder = 1) {
    let _this = this;
    let chainData = _this.chainData;

    let $chainedSelect = $('.js-select[data-chain="' + chainData + '"]');
    if (!$chainedSelect.length) return;

    let $nextChainedSelect = $chainedSelect.filter((i, select) => {
      return +$(select).data('chain-order') > chainOrder;
    });
    if (!$nextChainedSelect.length) return;

    $.each($nextChainedSelect, (i, select) => {
      let $currSelect = $(select);
      let values = $currSelect.data('_select').getValue();
      if (values.length) $currSelect.trigger('resetValues');
    });
  }

  showSelect() {
    let _this = this;
    let $select = _this.$container;

    $select.trigger('ddmenu.show');
  }

  hideSelect() {
    let _this = this;
    let $select = _this.$container;

    $select.trigger('ddmenu.hide', [ true ]);
  }

  static get(id) {
    let data = $('.js-select[data-select-id="' + id + '"]').data('_select');
    return data || null;
  }
}

export class ListSort {
  constructor(selector) {
    let _this = this;

    _this.$container = $(selector);
    _this._listSort = null;
    _this.listSortParams = _this.$container.data('listSortParams') || {};
    _this.listSortData = _this.$container.data('listsort');
    _this.$searchInp = $('js-listsort-input[data-listsort="' + _this.listSortData + '"]');

    _this._container = this;
    _this.$container.data('_listSort', _this._container);

    _this.init();
  }

  init() {
    let _this = this;

    _this.initListSort();
  }

  initListSort() {
    let _this = this;
    let $list = _this.$container;
    let listSortParams = _this.listSortParams;

    // _this.setListId();

    _this._listSort = new List($list.parent()[ 0 ], listSortParams);
  }

  initEvents() {
    let _this = this;
    let $list = _this.$container;
    let $searchInp = _this.$searchInp;

    $searchInp.on('');
  }

  searchValues(searchString, searchCols = null) {
    let _this = this;
    if (!searchString.length) {
      _this._listSort.search();
      return;
    }
    _this._listSort.search(searchString, searchCols);
  }

  filterValues(filterString, filterName) {
    let _this = this;
    if (!filterString.length) {
      _this._listSort.filter();
      return;
    }
    if (typeof filterString === 'string') {
      _this._listSort.filter((item) => {
        return item.values()[ filterName ] === filterString;
      });
    } else {
      _this._listSort.filter((item) => {
        return (filterString.indexOf(item.values()[ filterName ]) > -1);
      });
    }
  }

  setListId() {
    let _this = this;
    let $list = _this.$container;
    if (!$list[ 0 ].id) {
      let newId = `sortlist_${new Date().getTime()}`;
      $list.data('id', newId).attr('id', newId);
      $list[ 0 ].id = newId;
    }
    return $list;
  }

  reIndex() {
    let _this = this;
    _this._listSort.reIndex();
  }
}

// Toggle

export class Toggle {
  constructor(selector) {
    let _this = this;

    _this.$container = $(selector);
    _this.$checker = _this.$container.find('.toggle__check');
    _this.$bigToggleChecker = _this.$container.find('.bigtoggle__check');
    _this._container = this;

    this.$container.data('_toggle', _this._container);
    _this.init();
  }

  init() {
    let _this = this;
    let $container = _this.$container;
    let $checker = _this.$checker;
    let $bigChecker = _this.$bigToggleChecker;

    $checker.on('change', function (e) {
      $container.trigger('changed', [ _this.getValue() ]);
    });
    $bigChecker.on('change', function (e) {
      $container.trigger('changed', [ _this.getValue() ]);
    });
    $container.on('changed', function (e, value) {
      $container.data('value', value || null);
    });
  }

  getValue() {
    let _this = this;
    let $checker = _this.$checker;
    if (!$checker.length) {
      $checker = _this.$bigToggleChecker;
    }

    return $checker.filter(':checked').data('value');
  }

  static get(id) {
    let data = $('.js-toggle[data-toggle-id="' + id + '"]').data('_toggle');
    return data || null;
  }
}

// Right panel

class RightPanel {
  constructor(selector) {
    // let _this = this;
    this._container = this;
    this.$container = $(selector);
    this.isActive = false;
    this.$dragBox = this.$container.closest('.js-dragbox');

    this.$container.data('_rigntpanel', this._container);
    this.$objectTemplate = this.$container.find('.js-progress-steps__list').children().first();

    this.init();
  }

  init() {
    let _this = this;
    let $container = _this.$container;

    _this.initEvents();
  }

  initEvents() {
    let _this = this;
    let $container = _this.$container;

    $container.on('show', function () {
      _this.showPanel();
    });
    $container.on('hide', function () {
      _this.hidePanel();
    });
  }

  showPanel() {
    let _this = this;
    let $container = _this.$container;

    if (_this.isActive) return false;
    _this.isActive = true;
    $container.addClass('_active');
    $('html').addClass('right-panel-active');
  }

  hidePanel() {
    let _this = this;
    let $container = _this.$container;
    const $dragBox = _this.$dragBox;

    if (!_this.isActive) return false;
    _this.isActive = false;
    if (window.isMobile) $dragBox.data('_dragBox').hide();
    $container.removeClass('_active');
    $('html').removeClass('right-panel-active');
  }
}

// swipe

class Swipe {
  constructor(selector) {
    let _this = this;

    _this.$element = $(selector);

    if (window.isMobile) _this.init();
  }

  init() {
    let _this = this;

    _this.initHammer();
  }

  initHammer() {
    let _this = this;
    let $element = _this.$element;

    let hammerEl = new Hammer($element[ 0 ]);
    $element.data('_hammer', hammerEl);
  }
}

// popup

class Popup {
  constructor(selector) {
    let _this = this;

    _this.$popup = $(selector);
    _this.$link = $('[data-popup-target="' + _this.$popup.data('popup-id') + '"]');
    _this.isActive = false;

    _this.init();
  }

  init() {
    let _this = this;

    // _this.$wrapp = $('<div class="popup-wrapper" />');
    _this.$popup.wrapAll('<div class="popup-wrapper" />');
    _this.$wrapp = _this.$popup.closest('.popup-wrapper');
  }

  show() {
    let _this = this;
    if (_this.isActive) return false;
    _this.isActive = true;
    console.log(_this.$popup.add(_this.$wrapp));
    _this.$popup.add(_this.$wrapp).addClass('_active');
    _this.$popup.trigger('showed');
  }

  hide() {
    let _this = this;
    if (!_this.isActive) return false;
    _this.isActive = false;
    _this.$popup.add(_this.$wrapp).removeClass('_active');
    _this.$popup.trigger('hidden');
  }
}

class Popups {
  constructor() {
    let _this = this;

    _this.$popup = $('[data-popup-id]');
    _this.$link = $('[data-popup-target]');
    _this.$cover = $('.popup-cover');

    _this.init();
  }

  init() {
    let _this = this;

    _this.initPopup();
    _this.initEvents();
  }

  initPopup() {
    let _this = this;

    $.each(_this.$popup, function (i, popup) {

      $(popup).data('_popup', new Popup(popup));

    });
  }

  initEvents() {
    let _this = this;
    let $popup = _this.$popup;
    let $link = _this.$link;
    let $cover = _this.$cover;

    $popup.on('show', function () {
      let popId = $(this).data('popup-id');
      _this.show(popId);
    });
    $popup.on('hide', function () {
      let popId = $(this).data('popup-id');
      _this.hide(popId);
    });
    $popup.on('hidden', function () {
      let $currPopup = $(this);
      let $login = $currPopup.find('.js-login');

      if ($login.length) {
        setTimeout(function () {
          $login.trigger('reset');
        }, 300);
      }
    });
    $link.on('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      let linkData = $(this).data('popup-target');
      _this.toggle(linkData);
    });
    $cover.on('click', function (e) {
      _this.hideAll();
    });
    $(document).on('click', function (e) {
      let $target = $(e.target);

      if (_this.$popup.filter('._active').length && !$target.closest(_this.$popup).length) {
        _this.hideAll();
      }
    });
  }

  show(id) {
    let _this = this;
    let $popup = Popups.getPopup(id);

    if ($popup) {
      _this.$cover.addClass('_active');
      $('html').addClass('_popup-active');
      $popup.data('_popup').show();
    }
  }

  hide(id) {
    let _this = this;
    let $popup = Popups.getPopup(id);

    if ($popup) {
      _this.$cover.removeClass('_active');
      $('html').removeClass('_popup-active');
      $popup.data('_popup').hide();
    }
  }

  toggle(id) {
    let _this = this;
    let $popup = Popups.getPopup(id);

    if ($popup) {
      let _popup = $popup.data('_popup');
      if (_popup.isActive) {
        _this.$cover.removeClass('_active');
        $('html').removeClass('_popup-active');
        _popup.hide();
      } else {
        _this.$cover.addClass('_active');
        $('html').addClass('_popup-active');
        _popup.show();
      }
    }
  }

  hideAll() {
    let _this = this;
    _this.$cover.removeClass('_active');
    $('html').removeClass('_popup-active');

    $.each(_this.$popup, function (i, popup) {
      $(popup).data('_popup').hide();
    });
  }

  static getPopup(id) {
    return _Objects.Popups.$popup.filter('[data-popup-id="' + id + '"]') || null;
  }
}

export class MapData {
  constructor() {
    const _this = this;
    _this.timelineObj = _Objects.Timeline;
    _this.data = {};
  }

  hasData(yearData = false) {
    const _this = this;
    if (yearData) {
      return Object.keys(_this.getCurrentYearData()).length !== 0;
    }
    return Object.keys(_this.data).length !== 0;
  }

  hasStructureElements(structureType) {
    const _this = this;
    const currentYearData = _this.getCurrentYearData();
    const structurePropName = `${structureType}s`;

    return currentYearData[ structurePropName ].length !== 0;
  }

  hasElementDynamicData(structureType, structureId) {
    const currentYearData = this.getCurrentYearData();
    const structurePropName = `${structureType}sData`;
    return ('dynamicData' in currentYearData[ structurePropName ][ structureId ]);
  }

  hasStructureInfo(structureType, structureId) {
    const currentYearData = this.getCurrentYearData();
    return (structureType in currentYearData && structureId in currentYearData[ structureType ]);
  }

  hasProperty(propName, subField = '') {
    const _this = this;
    const currentYearData = _this.getCurrentYearData();
    if (subField.length) {
      return (subField in currentYearData[ propName ]);
    }

    return (propName in currentYearData);
  }

  getDataObject() {
    const _this = this;
    return _this.data;
  }

  getCurrentYearData() {
    const _this = this;
    const currentYear = _this.timelineObj.getValue();
    if (!(currentYear in _this.data)) {
      _this.data[ currentYear ] = {};
    }
    return _this.data[ currentYear ];
  }

  getStructureObject(structureType) {
    const _this = this;
    const currentYearData = _this.getCurrentYearData();
    const structurePropName = `${structureType}sData`;

    if (!(structurePropName in currentYearData)) {
      currentYearData[ structurePropName ] = {};
    }

    return currentYearData[ structurePropName ];
  }

  getStructureElements(structureType) {
    const _this = this;
    const currentYearData = _this.getCurrentYearData();
    const structurePropName = `${structureType}s`;

    return currentYearData[ structurePropName ];
  }

  getSearchData() {
    const _this = this;

    return _this.getCurrentYearData().searchItems;
  }

  getElementData(structureType, elementKey, dataType = '') {
    const _this = this;
    const currentYearData = _this.getCurrentYearData();
    const structurePropName = `${structureType}sData`;

    if (dataType.length !== 0) {
      const typePropName = `${dataType}Data`;
      if (undefined === currentYearData[ structurePropName ] ||
        undefined === currentYearData[ structurePropName ][ elementKey ]) {
        return undefined;
      }
      return currentYearData[ structurePropName ][ elementKey ][ typePropName ];
    } else {
      if (undefined === currentYearData[ structurePropName ]) {
        currentYearData[ structurePropName ] = {};
        return undefined;
      }
    }

    return currentYearData[ structurePropName ][ elementKey ];
  }

  findStructureElementByName(structureType, elementName) {
    const _this = this;
    const currentYearData = _this.getCurrentYearData();
    const structurePropName = `${structureType}s`;

    return currentYearData[ structurePropName ]
      .find(({ name }) => name === elementName);
  }

  filterStructureElements(structureType, elemProp, filterValue) {
    const _this = this;
    const currentYearData = _this.getCurrentYearData();
    const structurePropName = `${structureType}s`;

    return currentYearData[ structurePropName ]
      .filter((elem) => elem[ elemProp ] === filterValue);
  }

  setStructureData(data) {
    const _this = this;
    let currentYearData = _this.getCurrentYearData();
    const currentYear = _this.timelineObj.getValue();
    if (!Object.keys(currentYearData).length) {
      _this.data[ currentYear ] = { ...data };
    } else {
      _this.data[ currentYear ] = { ...currentYearData, ...data };
    }
  }

  setSearchStaticData(data, elements) {
    const _this = this;
    const currentYearData = _this.getCurrentYearData();
    elements.forEach((elem, i) => {
      const structurePropName = `${elem.type}sData`;
      currentYearData[ structurePropName ][ elem.name ] = {};
      currentYearData[ structurePropName ][ elem.name ][ 'staticData' ] = data[ i ].axisX[ 0 ].axisY;
    });
  }

  setCardElementData(structureType, structureName, data) {
    const _this = this;
    const structureData = _this.getStructureObject(structureType);
    structureData[ structureName ] = {};
    structureData[ structureName ][ 'staticData' ] = data.chart.axisY;
  }

  setStructureIndicatorStaticData(structureType, data, elements = []) {
    const _this = this;
    const structureData = _this.getStructureObject(structureType);
    const structureElements = (elements.length) ? elements : _this.getStructureElements(structureType);

    structureElements.forEach(({ name }, i) => {
      structureData[ name ] = {};
      structureData[ name ][ 'staticData' ] = data[ i ].axisX[ 0 ].axisY;
    });
  }

  setMultipleObjectsDynamicData(structureType, data, elements = []) {
    const _this = this;
    const structureData = _this.getStructureObject(structureType);
    const structureElements = (elements.length) ? elements : _this.getStructureElements(structureType);

    structureElements.forEach(({ name }, i) => {
      structureData[ name ].dynamicData = data[ i ].axisX;
    });
  }

  setStructureIndicatorDynamicData(structureType, structureName, data, subType) {
    const _this = this;
    const structureData = _this.getStructureObject(structureType);
    if (structureData[ structureName ].dynamicData === undefined) {
      structureData[ structureName ].dynamicData = {};
    }

    if (structureType === 'object') {
      structureData[ structureName ].dynamicData = data.chart[ 0 ].axisX;
    } else {
      structureData[ structureName ].dynamicData[ subType ] = {};
      structureData[ structureName ].dynamicData[ subType ] = data.chart[ 0 ].axisX;
    }
  }
}

// dragbox

class DragBox {
  constructor(selector) {
    let _this = this;

    if (!window.isMobile) return false;

    _this.$container = $(selector);
    _this.$dragLine = _this.$container.find('.js-dragline');

    _this.isActive = false;

    _this._container = this;
    _this.$container.data('_dragBox', _this._container);

    _this.init();
  }

  init() {
    let _this = this;

    _this.initHammer();

    _this.$dragLine.data('_hammer').on('panup pandown', (e) => {
      // console.log(e.type, e.direction, e.deltaY);
      _this.toggleBox(e.type === 'panup' ? 'up' : 'down');
    });

  }

  initHammer() {
    let _this = this;
    let $box = _this.$container;
    let $dragLine = _this.$dragLine;

    let hammerEl = new Hammer($dragLine[ 0 ]);
    hammerEl.get('pan').set({ direction: Hammer.DIRECTION_ALL });
    $dragLine.data('_hammer', hammerEl);
  }

  toggleBox(panDiretion = 'down') {
    let _this = this;

    if (panDiretion === 'up') _this.show();
    else _this.hide();
  }

  show() {
    let _this = this;

    if (_this.isActive) return false;
    _this.isActive = true;

    _this.$container.addClass('_opened');
    _this.$container.trigger('dragbox.showed');
  }

  hide() {
    let _this = this;

    if (!_this.isActive) return false;
    _this.isActive = false;

    _this.$container.removeClass('_opened');
    _this.$container.trigger('dragbox.hidden');
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/src/main.js